(function SortTasks($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/TaskListTemplates/sortTasks/', function onload()
		{
			dragula([$('.tasks')[0]], {
				revertOnSpill: true,
			})
			.on('drop', function dropIt(this_el, target, source, sibling)
			{
				handleSortOrder();
			});
		});
	});

	function handleSortOrder() {
		var sort_order  = '',
			counter     = 1,
			cur_html    = '',
			html_parts  = '';

		$('.task:not(.gu-mirror)').each(function processSort() {
			sort_order += $(this).data('id') + ',';
		});

		Adzuki.Ajax.get('/TaskListTemplates/processSortTasks/' + sort_order).then(function success(response) {
			$('.task').each(function assignNumbers() {
				cur_html =  $(this).html();

				html_parts = cur_html.split('.');

				$(this).html(counter + '. ' + html_parts[1]);
				counter++;
			});

			Adzuki.StatusMessage(null, 'Sort order has been saved', 'Sort Saved');
		});
	}
}(jQuery, window.Adzuki || {}));